import React, { PropsWithChildren } from 'react';

type PropsWithClassName<T> = PropsWithChildren<T> & { className?: string | undefined };

function createBasicWrapper<T, U extends PropsWithClassName<T> = PropsWithClassName<T>>(tagName: string) {
  return React.forwardRef(({ children = null, className, ...props }: PropsWithClassName<U>, forwardRef) =>
    React.createElement(
      tagName,
      {
        ...props,
        class: className,
        forwardRef,
      },
      children,
    ),
  );
}

export default createBasicWrapper;
